import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import "./MobileHeader.scss";
import { ArrowBackIosNew } from "@mui/icons-material";

interface MobileHeaderProps {
  title: string;
  onBack?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  onBack,
  className = "",
  style,
}) => {
  return (
    <Box
      className={`mobile-header ${className}`}
      style={style}
      component="header"
    >
      <IconButton
        onClick={onBack}
        className="mobile-header__back-btn"
        aria-label="Go back"
      >
        <ArrowBackIosNew />
      </IconButton>

      <Typography variant="h6" className="mobile-header__title">
        {title}
      </Typography>
    </Box>
  );
};

export default MobileHeader;
